export default "__VITE_ASSET__671150d7__"